import {createColumnHelper} from "@tanstack/react-table";
import {useNavigate} from "react-router-dom";
import DataTable from "../../../components/DataTable/DataTable";
import moment from "moment-timezone";

const columnHelper = createColumnHelper();
const columns = [
    columnHelper.accessor(value => moment(value.created).format("YYYY-MM-DD hh:mm"), {
        header: "Created",
        sortingFn: "datetime",
    }),
    columnHelper.accessor("cowNumber", {
        header: "Cow Number",
        sortingFn: "alphanumeric",
    }),
    columnHelper.accessor(value => moment(value.treatmentDate).format("YYYY-MM-DD"), {
        header: "Date",
        sortingFn: "datetime",
    }),
    columnHelper.accessor("product.name", {
        header: "Product",
    }),
    columnHelper.accessor("dosage", {
        header: "Dosage",
        cell: info => `${info.getValue()} ${info.row.original.unit}`,
        sortingFn: "alphanumeric",
    }),
    columnHelper.accessor(value => value.reason?.name, {
        header: "Reason",
    }),
    columnHelper.accessor("comments", {
        header: "Comments",
    }),
];

const ReactiveTreatmentsTable = ({reactiveTreatments}) => {
    const navigate = useNavigate();

    return <DataTable title="Reactive Treatments" data={reactiveTreatments} columns={columns} useFilter
                      onRowClick={(row) => navigate(row.id.toString())}/>;
}

export default ReactiveTreatmentsTable;